var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jielong-topic-bottom-bar"},[_c('div',{staticClass:"inner-wap"},[_c('div',{staticClass:"button",on:{"click":_vm.reply}},[_c('span',[_vm._v("接龙")])])]),_vm._v(" "),_c('div',{staticClass:"bottom-gap"})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-944a998c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topic/JielongTopicBottomBar.vue
// module id = 1607
// module chunks = 0